import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { InputSwitch } from 'primereact/inputswitch';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import { Skeleton } from 'primereact/skeleton';
import ButtonSeplag from '../buttonSeplag/ButtonSeplag';
import { useSelector } from 'react-redux';
import './TableSeplag.css';
import { getAllRoutesByPage } from '../../core/config/Permission';
import { useRouteMatch } from 'react-router-dom';
import InputTypes from '../../core/enums/InputTypes';
import { ACTIONS } from '../../core/enums/PermissionEnums';
import Shareds from '../../config/translations/Shareds';

const TableSeplag = ({
    config = null,
    service,
    lockButtonsRules,
    onAdicionarDado,
    enableSwitch = true,
    labelIncluir = 'Incluir',
    ...props
}) => {
    const routes = getAllRoutesByPage(useRouteMatch()['path']);
    config.setIncluirPermission(routes);
    config.setEditarPermission(routes);
    config.setConsultarPermission(routes);
    config.setDeletarPermission(routes);
    const count = useSelector((state) => state.counterRequestReducer.counterRequest);
    const isLoading = count > 0;

    const [selected, setSelected] = useState(props.inicioSeletor ? props.inicioSeletor : null);
    const dt = useRef(null);
    const [visible, setVisible] = useState(false);
    const [confirmSituacao, setConfirmSituacao] = useState(false);
    const [permitidoExecutarFuncao, setPermitidoExecutarFuncao] = useState(
        props.page !== undefined && props.page !== null ? false : true
    );
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
    });

    const [rows, setRows] = useState(10);
    const [expandedRows, setExpandedRows] = useState(null);

    useEffect(() => {
        const vRows = props.rows ? props.rows : 10;
        const vPage = props.page ? props.page : 0;

        setLazyParams({
            first: vPage > 0 ? vRows * vPage + 1 : 0,
            rows: vRows,
            page: vPage,
        });
        setRows(props.rows ? props.rows : 10);
    }, [props.page, props.rows]);

    const renderHeader = () => {
        if (props.hasCabecalhoDinamic) return;

        if (!(props.onAdicionarDado || props.onModalSearch || props.onSearch)) return;

        return (
            <div className="table-header p-grid p-fluid p-justify-between p-align-center">
                {props.onModalSearch && (
                    <div
                        className="flex w-full flex-row"
                        style={{ justifyContent: 'space-between' }}
                    >
                        <div>
                            {props?.addAditionalActions && props.addAditionalActions(props.dados)}
                            {onAdicionarDado &&
                                config.getAllPermissions(routes)[ACTIONS.INCLUIR] && (
                                    <Button
                                        label={labelIncluir}
                                        icon="pi pi-plus"
                                        disabled={
                                            typeof lockButtonsRules === 'function'
                                                ? lockButtonsRules({}).incluir
                                                : false
                                        }
                                        iconPos="left"
                                        className="p-button-info"
                                        onClick={onAdicionarDado}
                                    />
                                )}
                        </div>
                        <div>
                            {props.onExportar && (
                                <>
                                    <Button
                                        tooltip="Exportar em PDF"
                                        tooltipOptions={{ position: 'top' }}
                                        label=""
                                        icon="pi pi-file-pdf"
                                        className="p-button-raised p-button-secondary"
                                        onClick={() => props.onExportar('pdf')}
                                        style={{ marginRight: '10px' }}
                                    />
                                    <Button
                                        tooltip="Exportar em Excel"
                                        tooltipOptions={{ position: 'top' }}
                                        label=""
                                        icon="pi pi-file-excel"
                                        className="p-button-raised p-button-secondary"
                                        onClick={() => props.onExportar('excel')}
                                        style={{ marginRight: '10px' }}
                                    />
                                    <Button
                                        tooltip="Exportar em CSV"
                                        tooltipOptions={{ position: 'top' }}
                                        label=""
                                        icon="pi pi-file"
                                        className="p-button-raised p-button-secondary"
                                        onClick={() => props.onExportar('csv')}
                                        style={{ marginRight: '10px' }}
                                    />
                                    <Button
                                        tooltip="Imprimir"
                                        tooltipOptions={{ position: 'top' }}
                                        label=""
                                        icon="pi pi-print"
                                        className="p-button-raised p-button-secondary"
                                        onClick={() => props.onExportar('print')}
                                        style={{ marginRight: '10px' }}
                                    />
                                </>
                            )}
                            {props?.addAfterExport && props.addAfterExport(props.dados)}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const confirmarExclucao = () => {
        setVisible(false);
        props.onExcluirDado(selected);
    };

    const handleExcluir = (event, rowData) => {
        event.preventDefault();
        setSelected(rowData);
        setVisible(true);
    };

    const handleStatus = (event, rowData) => {
        event.preventDefault();
        setSelected(rowData);
        setConfirmSituacao(true);
    };

    const confirmarSituacao = () => {
        setConfirmSituacao(false);
        props.onAlterarStatus(selected, !selected.ativo);
    };

    const actionBotoes = (rowData) => {
        const {
            [ACTIONS.EDITAR]: EDITAR,
            [ACTIONS.DELETAR]: DELETAR,
            [ACTIONS.CONSULTAR]: CONSULTAR,
        } = config.getAllPermissions(routes, rowData);

        const {
            editar = false,
            ativar = false,
            excluir = false,
        } = lockButtonsRules ? lockButtonsRules(rowData) : {};
        return (
            <div className="acoesContainer">
                {props.addBeforeActions(rowData)}

                {props.onVisualizar && CONSULTAR && (
                    <ButtonSeplag
                        tipo="info"
                        type="button"
                        tooltip="Visualizar"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        onClick={() => props.onVisualizar(rowData)}
                        style={
                            props.onEditarDado
                                ? {
                                      marginRight: '.5em',
                                      marginTop: props.onExcluirDado ? '.2em' : '',
                                  }
                                : {}
                        }
                    />
                )}

                {props.onEditarDado && EDITAR && (
                    <ButtonSeplag
                        tipo="warning"
                        type="button"
                        tooltip="Editar"
                        disabled={editar}
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-pencil"
                        onClick={() => props.onEditarDado(rowData)}
                        style={
                            props.onExcluirDado ? { marginRight: '.5em', marginTop: '.2em' } : {}
                        }
                    />
                )}
                {props.onAlterarStatus && enableSwitch && EDITAR && (
                    <InputSwitch
                        checked={rowData.ativo}
                        tooltip={rowData.ativo ? 'Inativar' : 'Ativar'}
                        tooltipOptions={{ position: 'top' }}
                        disabled={ativar}
                        onChange={(e) => handleStatus(e, rowData)}
                        style={{ marginRight: '.5em', marginTop: '.5em' }}
                    />
                )}
                {props.onExcluirDado && DELETAR && (
                    <ButtonSeplag
                        tipo="danger"
                        type="button"
                        disabled={excluir}
                        tooltip="Excluir"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-trash"
                        className="p-button-danger p-mb-1"
                        onClick={(e) => handleExcluir(e, rowData)}
                        theme="Raised"
                    />
                )}
                {props.onImpressao && (
                    <Button
                        type="button"
                        style={{ marginLeft: '1vw', marginBottom: '1vh' }}
                        tooltip="Imprimir"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-print "
                        className="Primary"
                        onClick={() => props.onImpressao(rowData)}
                    />
                )}
                {props.onCalender && (
                    <Button
                        type="button"
                        icon="pi pi-calendar-plus"
                        className="Primary"
                        onClick={() => props.onCalender(rowData)}
                    />
                )}
                {props.botoesAcoes && props.botoesAcoes(rowData)}
                {props.addAfterActions(rowData)}
            </div>
        );
    };

    const colAtivoInativo = (rowData) => {
        return props.onAlterarStatus && <div>{rowData.ativo ? 'Ativo' : 'Inativo'}</div>;
    };

    const colunaTabela = (objeto, campo) => {
        var dataColuna = '';
        if (campo.nome.indexOf('.') < 0) {
            if (campo.displayFormat) {
                if (campo.displayFormat === 'currency-pt-br') {
                    const currencyBRL = (value) => {
                        const formattedValue = value.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                        });

                        return formattedValue;
                    };
                    return currencyBRL(objeto[campo.nome]);
                } else {
                    dataColuna = moment(objeto[campo.nome]).format(campo.displayFormat);
                    return dataColuna;
                }
            }

            return objeto[campo.nome] ? objeto[campo.nome] : 'Não Definido';
        } else {
            var arryCampos = campo.nome.split('.');
            let colunasArray = objeto;
            for (let i = 0; i < arryCampos.length; i++) {
                if (colunasArray[arryCampos[i]]) {
                    colunasArray = colunasArray[arryCampos[i]];
                } else {
                    break;
                }
            }

            if (campo.displayFormat) {
                if (moment(colunasArray).isValid()) {
                    dataColuna = moment(colunasArray).format(campo.displayFormat);
                    return dataColuna;
                }
            }

            if (colunasArray) {
                if (typeof colunasArray !== 'object') {
                    return colunasArray;
                } else {
                    return 'Não Informado';
                }
            } else {
                return '';
            }
        }
    };

    const Coluna = (rowData, campo) => {
        return <div>{colunaTabela(rowData, campo)}</div>;
    };

    const renderFooter = () => {
        return (
            <div>
                <ButtonSeplag
                    label="Sim"
                    type="button"
                    icon="pi pi-check"
                    iconPos="left"
                    onClick={confirmarExclucao}
                />
                <ButtonSeplag
                    label="Não"
                    type="button"
                    icon="pi pi-times"
                    iconPos="left"
                    onClick={() => setVisible(false)}
                    theme="Raised"
                />
            </div>
        );
    };

    const renderFooterSituacao = () => {
        return (
            <div>
                <ButtonSeplag
                    label="Sim"
                    type="button"
                    icon="pi pi-check"
                    iconPos="left"
                    onClick={confirmarSituacao}
                />
                <ButtonSeplag
                    label="Não"
                    type="button"
                    icon="pi pi-times"
                    iconPos="left"
                    onClick={() => setConfirmSituacao(false)}
                    theme="Raised"
                />
            </div>
        );
    };

    const handleOnPage = (event) => {
        if (permitidoExecutarFuncao) {
            if (props.onPage) {
                props.onPage(event);
            }
            let _lazyParams = { ...lazyParams, ...event };

            setLazyParams(_lazyParams);
            setRows(event.rows);
        } else {
            setPermitidoExecutarFuncao(true);
        }
    };

    if (isLoading) {
        return <TableLoader {...props} />;
    }

    function onSelectionChange(e) {
        setSelected(e.value);
        props.onSelectionChange && props.onSelectionChange(e.value);
    }
    return (
        <div className={'datatable-responsive-demo p-col-12 p-md-12'} style={{ overflowX: 'auto' }}>
            <DataTable
                ref={dt}
                value={service ? service.setDataTable(config, props.dados) : props.dados}
                header={renderHeader()}
                className={'p-datatable-responsive-demo'}
                dataKey={props.dataKey ? props.dataKey : 'id'}
                rowHover
                selection={selected}
                onSelectionChange={onSelectionChange}
                paginator={props.semPaginacao ? false : true}
                rows={rows}
                lazy={props.totalRecords ? true : false}
                emptyMessage={props.emptyMessage ?? 'Nenhum registro encontrado'}
                totalRecords={props.totalRecords}
                currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} registros"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 25, 50]}
                onPage={handleOnPage}
                first={lazyParams.first}
                onRowSelect={props.onRowSelect}
                selectionPageOnly
                selectionMode={props.selectionMode ? props.selectionMode : null}
                responsiveLayout="stack"
                breakpoint="960px"
                rowExpansionTemplate={props.rowExpansionTemplate}
                onRowExpand={props.onRowExpand}
                onRowCollapse={props.onRowCollapse}
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
            >
                {props.expander && <Column expander style={{ width: '3em' }} />}

                {props.selectionMode === 'multiple' && (
                    <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>
                )}

                {props.camposTabela &&
                    props.camposTabela
                        .filter(
                            (el) => !(el.titulo === 'Situação' && el.type === InputTypes.BOOLEAN)
                        )
                        .map((campo, i) => (
                            <Column
                                field={campo.nome}
                                header={campo.titulo}
                                body={(rowData) => Coluna(rowData, campo)}
                                key={i}
                            />
                        ))}
                {props.children}
                {props.onAlterarStatus &&
                    props.camposTabela
                        .filter((el) => el.titulo === 'Situação' && el.type === InputTypes.BOOLEAN)
                        .map((el) => el.titulo)
                        .includes('Situação') && (
                        <Column
                            headerStyle={{
                                width: props.tamnhoAcao ? props.tamnhoAcao : '8em',
                                textAlign: 'left',
                            }}
                            header="Situação"
                            bodyStyle={{ textAlign: 'left' }}
                            body={colAtivoInativo}
                        />
                    )}
                {props.hasEventoAcao && (
                    <Column
                        headerStyle={{
                            width: props.tamnhoAcao ? props.tamnhoAcao : '8em',
                            textAlign: 'center',
                        }}
                        header="Ações"
                        bodyStyle={{ textAlign: 'center' }}
                        body={actionBotoes}
                    />
                )}
            </DataTable>

            <Dialog
                header="Confirmação"
                visible={visible}
                footer={renderFooter()}
                onHide={() => setVisible(false)}
            >
                <p>{Shareds.form.confirmDelete}</p>
            </Dialog>
            <Dialog
                header="Confirmação"
                visible={confirmSituacao}
                footer={renderFooterSituacao()}
                onHide={() => setConfirmSituacao(false)}
            >
                <p>
                    Tem certeza que deseja prosseguir com a
                    {selected && !selected.ativo ? ' ativação' : ' inativação'} desse registro?
                </p>
            </Dialog>
        </div>
    );
};

TableSeplag.propTypes = {
    camposTabela: PropTypes.array.isRequired,
    dataKey: PropTypes.string,
    dados: PropTypes.array.isRequired,
    totalRecords: PropTypes.number,
    hasEventoAcao: PropTypes.bool,
    hasCabecalhoDinamic: PropTypes.bool,
    semPaginacao: PropTypes.bool,
    onView: PropTypes.func,
    onCalender: PropTypes.func,
    onAdicionarDado: PropTypes.func,
    botoesAcoes: PropTypes.func,
    onEditarDado: PropTypes.func,
    onAlterarStatus: PropTypes.func,
    onExcluirDado: PropTypes.func,
    onSearch: PropTypes.func,
    onImpressao: PropTypes.func,
    onExportar: PropTypes.func,
    onPage: PropTypes.func,
    onRowSelect: PropTypes.func,
    selectionMode: PropTypes.string,
    rowExpansionTemplate: PropTypes.func,
    onRowExpand: PropTypes.func,
    onRowCollapse: PropTypes.func,
    expander: PropTypes.bool,
};

export default TableSeplag;

const TableLoader = (props) => {
    const products = Array.from({ length: 10 });

    const bodyTemplate = () => {
        return <Skeleton></Skeleton>;
    };

    const renderHeader = () => {
        if (props.hasCabecalhoDinamic) return;

        if (!(props.onAdicionarDado || props.onModalSearch || props.onSearch)) return;

        return (
            <div className="table-header p-grid p-fluid p-justify-between p-align-center">
                {props.onAdicionarDado && (
                    <div className="p-col-12 p-md-3 p-lg-2">
                        <ButtonSeplag label="Adicionar" icon="pi pi-plus" iconPos="left" />
                    </div>
                )}
                {props.onModalSearch && (
                    <div className="p-col-12 p-lg-4" style={{ display: 'flex' }}>
                        {props.onExportar && (
                            <div>
                                <Skeleton width="4rem" height="2rem"></Skeleton>
                                <Skeleton width="4rem" height="2rem"></Skeleton>
                                <Skeleton width="4rem" height="2rem"></Skeleton>
                                <Skeleton width="4rem" height="2rem"></Skeleton>
                            </div>
                        )}
                    </div>
                )}
                {props.onSearch && (
                    <div className=" p-col-12 p-md-4">
                        <div className="p-grid p-fluid p-align-center">
                            <div className="p-col">
                                <Skeleton height="2rem" className="mb-2"></Skeleton>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className={'datatable-responsive-demo p-col-12'}>
            <DataTable
                className={'p-datatable-responsive-demo'}
                value={products}
                header={renderHeader()}
                responsiveLayout="stack"
                breakpoint="960px"
            >
                {props.camposTabela &&
                    props.camposTabela.map((campo, i) => (
                        <Column
                            field={campo.nome}
                            header={campo.titulo}
                            body={bodyTemplate}
                            key={i}
                        />
                    ))}
                {props.children}
                {props.hasEventoAcao && (
                    <Column
                        headerStyle={{
                            width: props.tamnhoAcao ? props.tamnhoAcao : '8em',
                            textAlign: 'center',
                        }}
                        bodyStyle={{ textAlign: 'center' }}
                        body={<Skeleton shape="circle" size="3rem" className="mr-2"></Skeleton>}
                        header="Ação"
                    />
                )}
            </DataTable>
        </div>
    );
};
